import React from 'react';
import ReactSwitch from 'react-switch';
import './FeeDetailsVisibilityToggle.scss';

export interface FeeDetailsVisibilityToggleProps {
    isFeeDetailsVisible: boolean;
    onToggle: (next: boolean) => void;
}

export const FeeDetailsVisibilityToggle = (props: FeeDetailsVisibilityToggleProps) => {
    return (
        <div className="fee-details-visibility-toggle">
            <strong>Show fee details to seller</strong>
            <ReactSwitch
                offColor="#d92550"
                checked={props.isFeeDetailsVisible}
                onChange={() => props.onToggle(!props.isFeeDetailsVisible)}
                height={22}
            />
        </div>
    );
};
